<template>
  <div class="out_wrap transparent home" style="padding:0;">
<!--    <div class="appletBox mb20 flex_between">-->
<!--      <div class="mr30">-->
<!--        <div class="fs24 mb20">系统小程序上线了</div>-->
<!--        <div class="lh26">1.扫码登录小程序，体验手机版操作系统。2.扫码关注公众号，接收小程序推送的消息，实时提醒更方便。-->
<!--          <div>温馨提醒：点击二维码可进行放大。</div></div>-->
<!--      </div>-->
<!--      <div class="flex_middle ml30">-->
<!--        <div class="mr20 pb20">-->
<!--          <div class="applt_img pointer" @click="webVisible = true">-->
<!--            <img src="../../assets/web2.png" alt="">-->
<!--          </div>-->
<!--          <div class="center mt5">公众号</div>-->
<!--        </div>-->
<!--        <div class="mr20 pb20">-->
<!--          <div class="applt_img pointer" @click="dialogVisible = true">-->
<!--            <img :src="logo" alt="">-->
<!--          </div>-->
<!--          <div class="center mt5">小程序</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="flex numBox">
      <div class="flex1 item recharge_bg">
        <div class="tit">累计总充值金额</div>
        <div class="value">
          <count-to :start-val="0" :end-val="summaryStatics.recharge_sum" :duration="duration" prefix="¥ " :decimals="2" separator="," :autoplay="true" />
        </div>
        <img class="shadow" src="../../assets/recharge.png">
      </div>
      <div class="flex1 item">
        <div class="tit">累计总服务费金额</div>
        <div class="value">
          <count-to :start-val="0" :end-val="summaryStatics.service_sum" :duration="duration" prefix="¥ " :decimals="2" separator="," :autoplay="true" />
        </div>
        <img class="shadow" src="../../assets/service.png">
      </div>
      <div class="flex1 item">
        <div class="tit">本月累计消耗金额</div>
        <div class="value">
          <count-to :start-val="0" :end-val="summaryStatics.pay_sum_cur_month" :duration="duration" prefix="¥ " :decimals="2" separator="," :autoplay="true" />
        </div>
        <img class="shadow" src="../../assets/consume.png">
      </div>
      <div class="flex1 item">
        <div class="tit flex_between">商户号累计可用金额 <span class="detail" @click="$router.push('/trade/refund')">详情</span></div>
        <div class="value">
          <count-to :start-val="0" :end-val="summaryStatics.available_sum" :duration="duration" prefix="¥ " :decimals="2" separator="," :autoplay="true" />
        </div>
        <img class="shadow" src="../../assets/use.png">
      </div>
      <div class="flex1 item">
        <div class="tit">当日支付金额</div>
        <div class="value" style="margin-top:15px;">
          <count-to :start-val="0" :end-val="summaryStatics.pay_info_sum" :duration="duration" prefix="¥ " :decimals="2" separator="," :autoplay="true" />
          <div class="num waituse-font">支付次数：{{ summaryStatics.pay_count }}</div>
        </div>
        <img class="shadow" src="../../assets/pay.png">
      </div>
    </div>
    <div class="middleBox flex mt20">
      <div class="flex1 white infoBox">
        <div class="flex_between mb20">
          <div class="left fs16 bold">支付金额</div>
          <div class="right flex_middle">
            <el-date-picker
              v-model="time"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :editable="false"
              :clearable="false"
              :value-format="'yyyy-MM-dd'"
              unlink-panels
              :picker-options="pickerOptions"
              size="mini"
              class="mr15"
              @change="type = '';getChart(1)"
            />
            <el-radio-group v-model="type" size="mini" @change="typeChange">
              <el-radio-button label="近一周" />
              <el-radio-button label="本月" />
              <el-radio-button label="近一年" />
            </el-radio-group>
          </div>
        </div>
        <div id="myChart" :style="{width: '100%', height: '322px'}" />
      </div>
      <div class="calendar white infoBox ml20">
        <div class="fs16 bold">支付异常日历</div>
        <el-divider />
        <el-calendar v-model="calendar" class="home-calendar">
          <template
            slot="dateCell"
            slot-scope="{data}"
          >
            <el-tooltip v-if="errorDate.includes(data.day)" effect="dark" content="支付异常" placement="top">
              <div :class="['center cell', errorDate.includes(data.day) ? 'active' : '']" @click="calendarOnClick(data, errorDate.includes(data.day))">
                {{ data.day.split('-').slice(2).join('-') }}
              </div>
            </el-tooltip>
            <div v-else :class="['center cell', errorDate.includes(data.day) ? 'active' : '']" @click="calendarOnClick(data)">
              {{ data.day.split('-').slice(2).join('-') }}
            </div>
          </template>
        </el-calendar>
      </div>
    </div>
    <div class="mt20 white infoBox">
      <div class="flex_between">
        <div class="fs16 bold">预警数据</div>
        <el-tooltip effect="dark" content="导出预警数据" placement="top">
          <el-button type="primary" size="mini" @click="exportUrl">导出</el-button>
        </el-tooltip>
      </div>
      <template v-if="warnData.length">
        <div class="warn-list">
          <div v-for="(item, index) in warnData" :key="index" class="item">
            <div class="left-con ellipsis" :title="item.openid">OPENID：{{ item.openid }}</div>
            <div class="mid-con flex1 ellipsis" :title="item.appid">APPID: {{ item.appid }}</div>
            <div class="right-con ellipsis" :title="`当月累计金额已达到￥${ $formatCurrency(item.month_amount) }请及时关注`">
              当月累计金额已达到￥{{ $formatCurrency(item.month_amount) }}请及时关注
            </div>
            <el-button class="authBtn" style="width:68px;" size="mini" :type="item.is_verify ? 'success' : 'primary'" @click="auth(item)">{{ item.is_verify ? '已认证' : '认证' }}</el-button>
          </div>
        </div>
        <el-pagination
          :current-page.sync="pages.page"
          :page-size="pages.pageSize"
          layout="total, prev, pager, next"
          :total="pages.total"
          @current-change="handleCurrentChange"
        />
      </template>
      <noData v-else />
    </div>
    <transition name="el-fade-in">
      <Version v-if="updateVersion" :content="versionContent" @Close="closeFn" />
    </transition>
    <el-dialog title="身份认证" :visible.sync="authFormVisible" width="400px" center :before-close="beforeClose">
      <el-form ref="authForm" :model="authForm" size="small" label-width="80px" :rules="authFormRules">
        <el-form-item label="姓 名：" prop="name">
          <el-input v-model="authForm.name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input v-model="authForm.phone" placeholder="请输入电话" />
        </el-form-item>
        <el-form-item label="身份证：" prop="idcard">
          <el-input v-model="authForm.idcard" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="OPENID：" prop="openid">
          <el-input v-model="authForm.openid" disabled placeholder="请输入openid" />
        </el-form-item>
        <el-form-item label="APPID：" prop="appid">
          <el-input v-model="authForm.appid" disabled placeholder="请输入appid" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" @click="sure">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="扫描小程序二维码" :visible.sync="dialogVisible" center width="350px">
      <div class="flex_center">
        <div class="applet_big_img">
          <img :src="logo" alt="">
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="扫描公众号二维码" :visible.sync="webVisible" center width="350px">
      <div class="flex_center">
        <div class="applet_big_img">
          <img src="../../assets/web2.png" alt="">
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="webVisible = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import echarts from 'echarts'
import dayjs from 'dayjs'
import countTo from 'vue-count-to'
import { mapGetters, mapMutations } from 'vuex'
import Version from '@/components/version'
import { indexStatics, getAbnormalInfo, payStatics, getWarnOpenIds, verifyOpenId, exportWarnOpenIds } from '@/api/home'
import exportFiles from '@/utils/exportFile'
import noData from '@/components/noData'
const validateMobile = (rule, value, callback) => {
  if (value) {
    if (!/^1[3456789]\d{9}$/.test(value)) {
      callback(new Error('请输入正确格式的手机号'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
export default {
  components: {
    countTo,
    noData,
    Version
  },
  data() {
    return {
      calendar: new Date(),
      time: '',
      type: '近一周',
      errorDate: [],
      page: 1,
      pageSize: 10,
      total: 100,
      summaryStatics: {},
      duration: 1000,
      warnData: [],
      pages: {
        page: 1,
        pageSize: 12,
        total: 0
      },
      authForm: {
        name: '',
        phone: '',
        idcard: '',
        openid: '',
        appid: ''
      },
      authFormRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validateMobile, trigger: 'change' }
        ],
        idcard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ]
      },
      authFormVisible: false,
      logo: process.env.NODE_ENV !== 'production' ? require('@/assets/applet_cs.jpg') : require('@/assets/applet_pro.png'),
      dialogVisible: false,
      webVisible: false
    }
  },
  computed: {
    ...mapGetters('user', ['updateVersion', 'versionContent'])
  },
  created: function() {
    this.$nextTick(() => {
      // 点击前一个月
      const prevBtn = document.querySelector(
        '.el-calendar__button-group .el-button-group>button:nth-child(1)'
      )
      prevBtn.addEventListener('click', e => {
        this.calendarData()
      })
      // 点击下一个月
      const nextBtn = document.querySelector(
        '.el-calendar__button-group .el-button-group>button:nth-child(3)'
      )
      nextBtn.addEventListener('click', () => {
        this.calendarData()
      })
      // 点击今天
      const todayBtn = document.querySelector(
        '.el-calendar__button-group .el-button-group>button:nth-child(2)'
      )
      todayBtn.addEventListener('click', () => {
        this.calendarData()
      })
    })
  },
  mounted() {
    this.getChart(2)
    this.calendarData()
    this.warnQuery()
    indexStatics().then(res => {
      if (res.code === 200) {
        this.summaryStatics = {
          available_sum: Number(res.data.available_sum) / 100,
          pay_sum_cur_month: Number(res.data.pay_sum_cur_month) / 100,
          pay_sum_prev_month: Number(res.data.pay_sum_prev_month) / 100,
          recharge_sum: Number(res.data.recharge_sum) / 100,
          service_sum: Number(res.data.service_sum) / 100,
          pay_info_sum: Number(res.data.pay_info.pay_sum) / 100,
          pay_count: res.data.pay_info.pay_count
        }
      }
    })
  },
  methods: {
    ...mapMutations('user', ['SET_UPDATEVERSION']),
    closeFn() {
      this.SET_UPDATEVERSION(!this.updateVersion)
    },
    calendarData() {
      getAbnormalInfo({ query_month: dayjs(this.calendar).format('YYYY-MM') }).then(res => {
        if (res.code === 200) {
          this.errorDate = res.data
        }
      })
    },
    // 点击日期块
    calendarOnClick(e, flag) {
      if (!flag) return
      this.$router.push({
        path: '/pay/list',
        query: {
          date: e.day
        }
      })
    },
    typeChange(e) {
      this.time = ''
      this.getChart(2)
    },
    async getChart(para) {
      let reqData = {}
      if (para === 2) {
        reqData = {
          start_day: '',
          end_day: '',
          type: this.type === '近一周' ? 1 : (this.type === '本月' ? 2 : 3)
        }
      } else {
        reqData = {
          start_day: this.time ? this.$dayFormat(this.time[0], 1) : '',
          end_day: this.time ? this.$dayFormat(this.time[1], 1) : '',
          type: this.type === '近一周' ? 1 : (this.type === '本月' ? 2 : 3)
        }
      }
      const res = await payStatics(reqData)
      if (res.code === 200) {
        this.echartsInfo(res.data)
      }
    },
    echartsInfo(data) {
      const xArr = []
      const yArr1 = []
      for (const i of data) {
        xArr.push(i.day)
        yArr1.push(!i.pay_sum || Number(i.pay_sum) === 0 ? 0 : ((Number(i.pay_sum) / 100).toString().indexOf('.') > -1 ? (Number(i.pay_sum) / 100).toFixed(2) : (Number(i.pay_sum) / 100)))
      }
      const myChart = echarts.init(document.getElementById('myChart'))
      myChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        xAxis: [{
          type: 'category',
          name: '日期',
          nameLocation: 'end',
          nameTextStyle: {
            color: '#999'
          },
          data: xArr,
          axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: [{
          type: 'value',
          name: '支付金额/元',
          nameLocation: 'end',
          nameTextStyle: {
            color: '#999'
          },
          splitLine: {
            lineStyle: {
              color: '#D9DDE6',
              type: 'dotted'
            }
          }
        }],
        series: [{
          name: '支付金额',
          type: 'bar',
          barWidth: '25%',
          data: yArr1,
          markPoint: {
            data: [
              { type: 'max', name: '最大值' },
              { type: 'min', name: '最小值' }
            ]
          },
          markLine: {
            data: [
              { type: 'average', name: '平均值' }
            ]
          },
          itemStyle: {
            normal: {
              color: '#2d8cf0',
              lineStyle: {
                color: '#2d8cf0'
              }
            }
          }
        }]
      })
      window.onresize = function() {
        myChart.resize()
      }
    },
    warnQuery() {
      getWarnOpenIds(this.pages).then(res => {
        if (res.code === 200 && res.data && res.data.list) {
          this.warnData = res.data.list.data
          this.pages.total = res.data.list.total
        }
      })
    },
    handleCurrentChange(val) {
      this.pages.page = val
      this.warnQuery()
    },
    async exportUrl() {
      if (!this.pages.total) {
        this.$message.error('暂无数据导出')
        return
      }
      const name = `${dayjs().format('YYYY-MM')}月支付超预警用户明细表`
      var res = await exportWarnOpenIds()
      if (res.type !== 'application/json') {
        exportFiles(res, name, 'xls')
      }
    },
    auth(item) {
      this.$nextTick(() => {
        this.authForm.openid = item.openid
        this.authForm.appid = item.appid
        this.authFormVisible = true
      })
    },
    cancel() {
      this.$refs.authForm.resetFields()
      this.authFormVisible = false
    },
    beforeClose(done) {
      this.$refs.authForm.resetFields()
      done()
    },
    async sure() {
      const res = await this.$refs.authForm.validate()
      if (res) {
        const result = await verifyOpenId(this.authForm)
        if (result.code === 200) {
          this.$message.success('提交成功')
          // 重置表单数据
          this.$refs.authForm.resetFields()
          this.warnQuery()
          this.authFormVisible = false
        }
      } else {
        console.error('验证失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.infoBox{
  border: 1px solid #EBEDF1;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 20px;
}
.numBox{
  .item{
    height: 128px;
    margin-right: 10px;
    position: relative;
    padding: 15px;
    box-sizing: border-box;
    color: #fff;
    border-radius: 12px;
    background-repeat: no-repeat;
    background-size: cover;
    &:nth-child(1){
      // background-image: url('../../assets/bg5.png');
      background: linear-gradient(270deg, #FE5E4F 0%, #ED4752 100%);
    }
    &:nth-child(2){
      // background-image: url('../../assets/bg2.png');
      background: linear-gradient(270deg, #24DED5 0%, #0EBCB4 100%);
    }
    &:nth-child(3){
      // background-image: url('../../assets/bg3.png');
      background: linear-gradient(270deg, #3A88FE 0%, #5456F9 100%)
    }
    &:nth-child(4){
      // background-image: url('../../assets/bg4.png');
      background: linear-gradient(270deg, #FFA94F 0%, #FF7B36 100%);
    }
    &:nth-child(5){
      // background-image: url('../../assets/bg1.png');
      background: linear-gradient(270deg, #964CFF 0%, #8C38FF 100%);
    }
    &:last-child{
      margin-right: 0;
    }
    .tit{
      margin-top: 15px;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
      .detail{
        display: inline-block;
        padding: 2px;
        border-radius: 2px;
        border: 1px solid #FFFFFF;
        cursor: pointer;
        margin-left: 2px;
        font-size: 12px;
      }
    }
    .value{
      text-align: center;
      font-size: 22px;
      margin-top: 20px;
      .num{
        font-size: 13px;
        margin-top: 5px;
      }
    }
    .shadow{
      position: absolute;
      right: 0;
      bottom: 0px;
      // width: 72px;
      height: 76px;
    }
  }
}
::v-deep{
  .el-divider--horizontal{
    margin: 10px 0;
  }
  .el-calendar-table .el-calendar-day{
    height: auto;
  }
  .home-calendar{
    .el-calendar__header{
      padding: 0 0 12px;
    }
    .el-calendar__body{
      padding: 0;
    }
    .el-calendar-table td{
      border: none;
    }
    .cell{
      height:30px;
      line-height:30px;
      &.active{
        background-color: #BA0000;
        color: #fff;
        border-radius: 50%;
      }
    }
  }
  .el-calendar-table .el-calendar-day{
    padding: 6px 8px;
  }
  .el-backtop, .el-calendar-table td.is-today{
    color: #333;
  }
  .el-pagination{
    padding: 10px 5px 0;
  }
}
.calendar{
  width: 365px;
}
.warn-list{
  display: flex;
  flex-wrap: wrap;
  // height: 250px;
  overflow-y: auto;
  .item{
    width: 49%;
    display: flex;
    padding-top: 5px;
    padding-bottom: 5px;
    box-sizing: border-box;
    align-items: center;
    .left-con{
      flex: 1.3;
    }
    .mid-con{
      padding-left: 20px;
    }
    .right-con{
      flex: 1.3;
      padding-left: 20px;
      box-sizing: border-box;
      color: #BA0000;
    }
    .authBtn{
      margin-left: 10px;
    }
    &:nth-child(odd){
      padding-right: 10px;
      border-right: 1px solid #D8D8D8;
    }
    &:nth-child(even){
      padding-left: 20px;
    }
  }
}
.lh26{
  line-height: 26px;
}
.appletBox{
  background-color: #EBF0FE;
  border-radius: 4px;
  padding: 15px 90px 15px 30px;
  // height: 140px;
  .applt_img{
    width: 94px;
    height: 94px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .applet_big_img{
    width: 188px;
    height: 188px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .mt5{
    margin-top: 5px;
  }
}
</style>
